/** Descrições dos tablets — espelham `statusView.js` (desktop). */
export const STATUS_FLOW_DESCRIPTIONS = {
  correios: {
    CART: "Cliente adiciona pedido no carrinho",
    PROCESSED: "Pagamento é processado",
    APPROVED: "Pagamento é autorizado",
    SENT: "Cliente envia o pedido",
    QUEUE: "Manafix recebe o pedido",
    GRADING: "Manafix começa a avaliação",
    GRADED: "Manafix termina a avaliação",
    RETURNED: "Manafix envia o pedido",
    DONE: "Manafix finaliza o processo",
  },
  presencial: {
    CART: "Cliente adiciona pedido no carrinho",
    PROCESSED: "Pagamento é processado",
    APPROVED: "Pagamento é autorizado",
    QUEUE: "Manafix recebe o pedido",
    GRADING: "Manafix começa a avaliação",
    GRADED: "Manafix termina a avaliação",
    AWAITING: "Aguardando cliente retirar o pedido",
    DONE: "Manafix finaliza o processo",
  },
  hub: {
    CART: "Cliente adiciona pedido no carrinho",
    PROCESSED: "Pagamento é processado",
    APPROVED: "Pagamento é autorizado",
    HOLD: "Parceiro recebe o pedido",
    QUEUE: "Manafix busca o pedido",
    GRADING: "Manafix começa a avaliação",
    GRADED: "Manafix termina a avaliação",
    AWAITING: "Aguardando cliente retirar o pedido",
    DONE: "Manafix finaliza o processo",
  },
};

export const STATUS_FLOW_COLORS = {
  correios: "#F9C0A0",
  presencial: "#F18992",
  hub: "#EA99C7",
};
